<template>
  <section class="case-container">
    <div ref="container" class="case-container-content max-width">
      <div class="left">
        <div class="swiper-container">
          <div class="swiper-box">
            <swiper
              v-if="swiperIsShow"
              ref="caseSwiper"
              :options="caseSwiperOption"
            >
              <swiper-slide v-for="(slide, index) in filterCase" :key="index">
                <div class="group-item">
                  <img :src="slide.cover | imgFilter" class="group-bg" />

                  <div
                    class="hide-view-container"
                    @click="
                      $router.push({
                        path: '/detail',
                        query: { id: slide.news_id },
                      })
                    "
                  >
                    <div class="hide-view-content">
                      <div class="sub-title font-size-26" :title="slide.title">
                        {{ slide.title }}
                      </div>
                      <div
                        class="content font-size-16"
                        :title="slide.introduce"
                      >
                        <!-- 在线管理工程项目，跟踪工程进度
                        审批工程各项报表的管理系统-->
                        {{ slide.introduce }}
                      </div>
                      <div
                        class="detail font-size-14"
                        @click="
                          $router.push({
                            path: '/detail',
                            query: { id: slide.news_id },
                          })
                        "
                      >
                        查看详情
                      </div>
                    </div>
                  </div>

                  <!-- <div class="group-item-bottom">
                    <div class="font-size-14">{{slide.company}}</div>
                    <div class="font-size-14 two-line-hide">{{slide.title}}</div>
                  </div> -->
                </div>
              </swiper-slide>
            </swiper>
            <div
              class="swiper-btn-next"
              @click="switchCaseSwiperPage(true)"
            ></div>
            <div
              class="swiper-btn-prev"
              @click="switchCaseSwiperPage(false)"
            ></div>
          </div>
          <div class="select-item-container"></div>
        </div>
      </div>
      <div class="right">
        <div class="title-container">
          <div class="main-title">OUR</div>
          <div class="sub-title">PROJECTS</div>
        </div>
        <h5 class="content-title">客户案例</h5>
        <p class="case-text">
          久凌致力于为不同行业提供专业化的解决
          方案，总结多年来服务各行业的经验和行
          业特点，定制政企、电商、等多个的案例
        </p>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "customer-case",
  computed: {
    ...mapGetters("cases", ["cases"]),
    filterCase() {
      return this.cases.filter((item) => item.type == this.active);
    },
  },
  watch: {
    filterCase() {
      this.swiperIsShow = false;
      this.$nextTick(() => {
        this.swiperIsShow = true;
      });
    },
  },
  data() {
    return {
      caseSwiperOption: {
        slidesPerView: 1,
        slidesPerGroup: 1,
        loopAdditionalSlides: 2,
        // autoplay: {
        //   delay: 1000,//1秒切换一次
        // },
        loop: true,
        loopFillGroupWithBlank: true,
      },
      active: 1,
      swiperIsShow: true,
    };
  },
  created() {
    this.initData();
  },
  methods: {
    switchCaseSwiperPage(state = false) {
      console.log(this.$refs.caseSwiper);
      if (state) {
        this.$refs.caseSwiper.swiper.slideNext();
      } else {
        this.$refs.caseSwiper.swiper.slidePrev();
      }
    },
    select(id) {
      this.active = id;
    },
    ...mapActions("cases", ["initData"]),
  },
};
</script>
<style lang="scss" scoped>
@import url("~@/assets/css/common.scss");
.two-line-hide {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
.case-container {
  padding: 130px 0;
  background-color: #fff;
  overflow-y: auto;
  .case-container-content {
    max-width: 1366px;
    margin: auto;
    display: flex;
    justify-content: center;
    .left {
      flex-grow: 3;
      flex-shrink: 0;
      position: relative;
      > .swiper-container {
        overflow: inherit;
        width: 840px;
        min-height: 200px;
        @media screen and(max-width: 1100px) {
          width: calc(840 / 1080 * 650px);
        }
        position: static;
        .swiper-box {
          position: relative;
          .swiper-btn-next,
          .swiper-btn-prev {
            outline: none;
            background-color: #f5f5f5;
            position: absolute;
            width: 4vh;
            height: 8vh;
            top: 40%;
            margin: auto;
            z-index: 20;
            cursor: pointer;
            background-size: 40%;
            background-repeat: no-repeat;
            background-position: center;
          }
          .swiper-btn-prev {
            left: -4vh;
            background-image: url("~@/assets/icon/arrow_left.svg");
          }
          .swiper-btn-next {
            right: -4vh;
            background-image: url("~@/assets/icon/arrow_right.svg");
          }
          .select-item-container {
            padding-bottom: 4vw;
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            flex-wrap: wrap;
            min-height: 4vh;
            position: relative;
            box-sizing: border-box;
            padding-left: 2.5%;
            &:before {
              content: "";
              background-color: #001238;
              position: absolute;
              left: -6vw;
              right: 6vw;
              top: -2vw;
              bottom: 2vw;
            }
            .select-item {
              user-select: none;
              color: #fff;
              font-size: 0.6vw;
              padding: 10px 0;
              padding-top: 20px;
              margin: 0 20px;
              cursor: pointer;
              position: relative;
              z-index: 1;
            }
            .active {
              box-sizing: border-box;
              position: relative;
              &::before {
                content: "";
                position: absolute;
                pointer-events: none;
                bottom: 2px;
                left: 0;
                right: 0;
                border-bottom: 2px solid #fff;
              }
            }
          }
        }
      }
      .group-item {
        height: 381px;
        overflow: hidden;
        position: relative;
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
        // margin-right: 143px;
        &:hover {
          .group-bg {
            transform: scale(1.05);
          }
        }
        @media screen and(max-width: 1100px) {
          // width: calc(275 / 1080 * 650px);
          height: calc(381 / 1080 * 650px);
          .content {
            -webkit-line-clamp: 1;
          }
        }
        cursor: pointer;
        .group-bg {
          height: 100%;
          transition: all 1s;
          width: 100%;
        }
        .group-item-bottom {
          position: absolute;
          bottom: -2px;
          left: 0;
          right: 0;
          transition: all 0.5s;
          color: #fff;
          font-size: 0.5vw;
          box-sizing: border-box;
          padding: 1.5vw;
          background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5));
        }
        &:hover > .group-item-bottom {
          bottom: -100%;
        }
        &:hover > .hide-view-container {
          top: 0;
        }
        .hide-view-container {
          position: absolute;
          transition: all 0.5s;
          top: 100%;
          left: 0;
          right: 0;
          width: 100%;
          height: 100%;
          box-sizing: border-box;
          color: #fff;
          overflow-y: auto;
          background-image: linear-gradient(0deg, #ffffff00, #38383880);
          .hide-view-content {
            position: relative;
            width: 100%;
            min-height: 100%;
            padding-top: 10%;
            box-sizing: border-box;
            padding-bottom: 20px;
          }
          .title {
            margin: 0 5%;
            line-height: 180%;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
          }
          @media screen and(max-width: 1100px) {
            .content {
              -webkit-line-clamp: 1;
              flex-shrink: 0;
            }
          }
          .sub-title {
            margin-top: 8%;
            margin: 0 5%;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            line-height: 180%;
            margin-bottom: 24px;
          }
          .content {
            word-break: break-all;
            // font-size: 0.5vw;
            margin-top: 10%;
            line-height: 1.5vw;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            margin: 0 5%;
            line-height: 180%;
            width: 50%;
          }
          .detail {
            box-sizing: border-box;
            border: 1px solid #fff;
            margin: 0 5%;
            margin-top: 5%;
            width: 96px;
            height: 32px;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-shrink: 0;
            // position: absolute;
            // bottom: 12%;
            &:hover {
              background-color: #fff;
              color: #333;
            }
          }
        }
      }
    }
    .right {
      flex-grow: 1;
      flex-shrink: 0;
      user-select: none;
      align-self: flex-end;
      margin: 0 6.5vw;
      position: relative;
      &:before {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 60px;
        height: 3px;
        background-color: #30659b;
      }
      .title-container {
        font-weight: bold;
      }
      .content-title {
        font-size: 18px;
        margin: 0;
      }
      .case-text {
        font-size: 14px;
        max-width: 281px;
        line-height: 220%;
        margin-bottom: 40px;
      }
    }
  }
}
</style>
